export const width = window.innerWidth;
export const isMobile = width <= 500;
export const isTablet = width <= 768;
export const isDesktop = width > 768;